import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import MediaQueries from 'react-responsive';

import Align from '@marvelapp/marvel-ui/align';
import Button from '@marvelapp/marvel-ui/button';
import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';

export default function ImageRightSection({
  artwork,
  buttonText,
  copy,
  link,
  title,
}) {
  return (
    <Grid columns={12} alignItems="center">
      <GridItem columnSpan={12} columnSpanM={6}>
        <MediaQueries maxWidth={770}>
          <Spacing size="l" type="margin" position="bottom">
            {artwork}
          </Spacing>
        </MediaQueries>
        <Spacing size="m" type="margin" position="bottom">
          <HeadingBlock
            maxWidth={420}
            justifyContent="center"
            justifyM="start"
            alignContent="center"
            alignM="left"
            title={title}
            copy={copy}
          />
        </Spacing>
        <Align type="center" typeM="left">
          <Link to={link}>
            <Button shape="rounded" kind="ghost" size="large">
              {buttonText}
            </Button>
          </Link>
        </Align>
      </GridItem>
      <GridItem columnSpan={12} columnSpanM={6}>
        <MediaQueries minWidth={770}>{artwork}</MediaQueries>
      </GridItem>
    </Grid>
  );
}

ImageRightSection.propTypes = {
  artwork: PropTypes.object,
  buttonText: PropTypes.string,
  copy: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  link: PropTypes.string,
  title: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/modules/ImageRightBlock/index.js